<template>
  <el-popover width="400" trigger="click">
    <div class="file-list-container">
      <div class="title">进度列表</div>
      <cube-tabs v-model="activeName" size="small" class="tabs-box">
        <cube-tab-pane label="上传中" name="upload"> </cube-tab-pane>
        <cube-tab-pane label="下载中" name="download"> </cube-tab-pane>
        <cube-tab-pane label="已结束" name="end"> </cube-tab-pane>
      </cube-tabs>
      <slot :activeName="activeName">
        <el-empty v-if="!idsList.length" description="暂无内容"></el-empty>
        <template v-else>
          <el-checkbox-group v-model="checkedFiles" @change="handleCheckedFileChange">
            <el-menu class="el-menu-vertical-demo" :default-openeds="openMenus" @open="handleOpen" @close="handleClose">
              <el-submenu
                v-for="(pageItem, pageIndex) in listData[activeName]"
                :key="pageIndex"
                :index="pageIndex"
              >
                <template slot="title">
                  <span>{{ pageItem.pathName }}</span>
                </template>
                <el-menu-item
                  v-for="(item, index) in pageItem.itemList"
                  :key="index"
                  :index="item.id"
                  style="padding: 0"
                >
                  <el-checkbox :label="item.id" :style="styleVar">
                    <cube-file-item
                      :title="item.title"
                      :time="item.time"
                      :file-type="item.fileType"
                      :type="item.type"
                      :process="item.process"
                      is-num
                      class="checkbox-file-item"
                      :info-item="item"
                      @cancel="onCancel"
                      @delete="onDelete"
                    >
                    </cube-file-item>
                  </el-checkbox>
                </el-menu-item>
              </el-submenu>
            </el-menu>
          </el-checkbox-group>
          <div class="flexCB file-list-bottom">
            <div class="left-btn">
              <span v-if="!isManage" class="pointer" @click="isManage = !isManage">管理</span>
              <span v-else>
                <el-checkbox
                  v-model="checkAll"
                  :indeterminate="isIndeterminate"
                  @change="handleCheckAllChange"
                  >全选 {{ checkText }}</el-checkbox
                >
              </span>
            </div>
            <div class="right-btn">
              <span v-if="!isManage">共12条</span>
              <span v-else>
                <span
v-if="activeName !== 'end'"
class="cancel pointer"
@click="checkCancel"
                  >取消</span
                >
                <span v-else class="cancel pointer" @click="checkDelete">删除</span>
                <span class="pointer quit" @click="isManage = !isManage">退出</span></span
              >
            </div>
          </div>
        </template>
      </slot>
    </div>

    <template #reference>
      <slot name="activateBtn"><i class="el-icon-sort"></i></slot>
    </template>
  </el-popover>
</template>

<script>
// import '../../../../lib/styles/components/FileList.scss'
export default {
  name: 'FileList',
  props: {
    // listData: {
    //   type: Array,
    // }
  },
  data() {
    return {
      isIndeterminate: true,
      isManage: false,
      checkAll: false,
      activeName: 'upload',
      listData: {
        upload: [
          {
            path: '/test',
            pathName: '测试1',
            itemList: [
              {
                id: 1,
                title: 'aaaaa.png',
                time: '2024年10月19日 23:56',
                fileType: 'upload',
                type: 'progressing',
                process: '40%'
              },
              {
                id: 2,
                title: 'bbbbb.png',
                time: '2025年10月19日 23:56',
                fileType: 'upload',
                type: 'progressing',
                process: '20%'
              }
            ]
          },
          {
            path: '/test',
            pathName: '测试2',
            itemList: [
              {
                id: 3,
                title: 'ccccc.png',
                time: '2026年10月19日 23:56',
                fileType: 'upload',
                type: 'progressing',
                process: '70%'
              },
              {
                id: 4,
                title: 'ddddd.png',
                time: '2027年10月19日 23:56',
                fileType: 'upload',
                type: 'progressing',
                process: '10%'
              },
              {
                id: 5,
                title: 'eeeeee.png',
                time: '2027年10月19日 23:56',
                fileType: 'upload',
                type: 'progressing',
                process: '90%'
              },
              {
                id: 66,
                title: 'eeeeee.png',
                time: '2027年10月19日 23:56',
                fileType: 'upload',
                type: 'progressing',
                process: '90%'
              },
              {
                id: 77,
                title: 'eeeeee.png',
                time: '2027年10月19日 23:56',
                fileType: 'upload',
                type: 'progressing',
                process: '90%'
              },
              {
                id: 88,
                title: 'eeeeee.png',
                time: '2027年10月19日 23:56',
                fileType: 'upload',
                type: 'progressing',
                process: '90%'
              }
            ]
          }
        ],
        download: [
          {
            path: '/test',
            pathName: '下载中测试页1',
            itemList: [
              {
                id: 6,
                title: 'qqqqqqqqqqqqqqqqqqqqqqqqqqqqq.png',
                time: '2024年1月9日 23:56',
                fileType: 'download',
                type: 'progressing',
                process: '80%'
              },
              {
                id: 7,
                title: 'mmmmmmmmm.png',
                time: '2085年10月19日 23:56',
                fileType: 'download',
                type: 'progressing',
                process: '75%'
              }
            ]
          }
        ],
        end: [
          {
            path: '/test',
            pathName: '已结束测试页1',
            itemList: [
              {
                id: 8,
                title: 'fffff.png',
                time: '2024年1月9日 23:56',
                fileType: 'download',
                type: 'canceled',
                process: '80%'
              },
              {
                id: 9,
                title: 'mmmmmmmmm.png',
                time: '2085年10月19日 23:56',
                fileType: 'download',
                type: 'success',
                process: '75%'
              }
            ]
          }
        ]
      },
      checkedFiles: [],
      openMenus: [0, 1]
    }
  },
  computed: {
    // 选中几个文字显示
    checkText() {
      return this.checkedFiles.length + '/' + this.idsList.length
    },
    // 根据不同的tabs计算出对应的所有的文件id数组
    idsList() {
      const arr = []
      this.listData[this.activeName].forEach((pathItem) => {
        if (pathItem.itemList && pathItem.itemList.length) {
          arr.push(...pathItem.itemList.map((item) => item.id))
        }
      })
      return arr
    },
    display() {
      return this.isManage ? 'block' : 'none'
    },
    styleVar() {
      return {
        '--display': this.display
      }
    }
  },
  watch: {
    // 切换tabs初始化选中
    activeName() {
      this.checkAll = false
      this.handleCheckAllChange(false)
    },
    // 防止显示复选框时会选中勾选框
    isManage(newV) {
      newV && this.handleCheckAllChange(false)
    }
  },
  methods: {
    // 全选操作
    handleCheckAllChange(val) {
      this.checkedFiles = val ? this.idsList : []
      this.isIndeterminate = false
    },
    handleCheckedFileChange(value) {
      console.log(value, '勾选改变')
      const checkedCount = value.length
      this.checkAll = checkedCount === this.idsList.length
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.idsList.length
    },
    handleOpen(key, keyPath) {
      console.log(key, keyPath)
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath)
    },
    onCancel(e) {
      this.$emit('cancel', [e.id])
    },
    onDelete(e) {
      this.$emit('delete', [e.id])
    },
    checkCancel() {
      this.$emit('cancel', this.checkedFiles)
    },
    checkDelete() {
      this.$emit('delete', this.checkedFiles)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../../lib/styles/components/FileList.scss';
// ::v-deep .el-tabs .el-tabs__header,
// ::v-deep .el-tabs .el-tabs__header .el-tabs__nav-wrap .el-tabs__item,
// ::v-deep .el-menu,
// ::v-deep .el-menu-item:hover,
// ::v-deep .el-submenu__title:hover {
//   background-color: unset !important;
// }
// .el-checkbox {
//   ::v-deep .el-checkbox__input {
//     display: var(--display);
//     padding-right: $--theme-spacing-02;
//   }
// }
</style>
